import { CaretLeftIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";

const MenuList = ({extendedSettings,id}) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };
 

  const items =  JSON.parse(settings.items.value)

  // Settings'ten değerleri al
  const containerPaddingX = settings.containerPaddingX.value + "px";
  const containerPaddingY = settings.containerPaddingY.value + "px";
  const containerBackgroundColor = settings.containerBackgroundColor.value;
  const itemBackgroundColor = settings.itemBackgroundColor.value;
  const itemHoverBackgroundColor = settings.itemHoverBackgroundColor.value;
  const itemTextColor = settings.itemTextColor.value;
  const itemHoverTextColor = settings.itemHoverTextColor.value;
  const backButtonBackgroundColor = settings.backButtonBackgroundColor.value;
  const backButtonHoverBackgroundColor =
    settings.backButtonHoverBackgroundColor.value;
  const backButtonTextColor = settings.backButtonTextColor.value;
  const backButtonIconColor = settings.backButtonIconColor.value;
  const borderColor = settings.borderColor.value;
  const itemFontSize = settings.itemFontSize.value + "px";
  const backButtonFontSize = settings.backButtonFontSize.value + "px";
  const itemFontWeight = settings.itemFontWeight.value;
  const backButtonFontWeight = settings.backButtonFontWeight.value;
  const itemPaddingY = settings.itemPaddingY.value + "px";
  const itemPaddingX = settings.itemPaddingX.value + "px";
  const backButtonPaddingY = settings.backButtonPaddingY.value + "px";
  const backButtonPaddingX = settings.backButtonPaddingX.value + "px";
  const borderWidth = settings.borderWidth.value + "px";
  const itemBorderRadius = settings.itemBorderRadius.value + "px";
  const backButtonBorderRadius = settings.backButtonBorderRadius.value + "px";
  const iconSize = settings.iconSize.value;
  const iconMarginRight = settings.iconMarginRight.value + "px";
  const itemMarginBottom = settings.itemMarginBottom.value + "px";
  const backButtonMarginBottom = settings.backButtonMarginBottom.value + "px";
  const showBorder = settings.showBorder.value;
  const showBackButton = settings.showBackButton.value;
  const showIcon = settings.showIcon.value;
  const borderPosition = settings.borderPosition.value;
  const hoverAnimation = settings.hoverAnimation.value;
  const animationDuration = settings.animationDuration.value + "ms";
  const mainMenuLabel = settings.mainMenuLabel.value;

  const [showedItems, setShowedItems] = useState([
    {
      id: -1,
      name: mainMenuLabel,
      child: items,
    },
  ]);

  const navigate = useNavigate();

  const onItemClick = (item) => {
    if (item?.child?.length > 0) {
      setShowedItems((prev) => [...prev, item]);
    } else {
      navigate(`/category`, {
        state: {
            name:item.label,
            id:item.id
        },
      });
    }
  };

  const onBackClick = () => {
    setShowedItems((prev) => prev.slice(0, -1));
  };

  const getBorderStyle = () => {
    if (!showBorder || borderPosition === "none") return {};

    const borderStyle = `${borderWidth} solid ${borderColor}`;
    switch (borderPosition) {
      case "bottom":
        return { borderBottom: borderStyle };
      case "top":
        return { borderTop: borderStyle };
      case "all":
        return { border: borderStyle };
      default:
        return {};
    }
  };
  return (
    <div
      style={{
        paddingLeft: containerPaddingX,
        paddingRight: containerPaddingX,
        paddingTop: containerPaddingY,
        paddingBottom: containerPaddingY,
        backgroundColor: containerBackgroundColor,
      }}
    >
      {showedItems[showedItems.length - 2] && showBackButton && (
        <div
          style={{
            display: "flex",
            cursor: "pointer",
            alignItems: "center",
            paddingTop: backButtonPaddingY,
            paddingBottom: backButtonPaddingY,
            paddingLeft: backButtonPaddingX,
            paddingRight: backButtonPaddingX,
            fontWeight: backButtonFontWeight,
            fontSize: backButtonFontSize,
            backgroundColor: backButtonBackgroundColor,
            color: backButtonTextColor,
            borderRadius: backButtonBorderRadius,
            marginBottom: backButtonMarginBottom,
            transition: hoverAnimation
              ? `all ${animationDuration} ease`
              : "none",
          }}
          onClick={onBackClick}
          onMouseEnter={(e) => {
            if (hoverAnimation) {
              e.target.style.backgroundColor = backButtonHoverBackgroundColor;
            }
          }}
          onMouseLeave={(e) => {
            if (hoverAnimation) {
              e.target.style.backgroundColor = backButtonBackgroundColor;
            }
          }}
        >
          {showIcon && (
            <CaretLeftIcon
              size={iconSize}
              color={backButtonIconColor}
              style={{ marginRight: iconMarginRight }}
            />
          )}
          <div>{showedItems[showedItems.length - 1].name}</div>
        </div>
      )}
      {showedItems[showedItems.length - 1]?.child.map((item) => (
        <div
          key={item.id}
          style={{
            cursor: "pointer",
            ...getBorderStyle(),
            paddingTop: itemPaddingY,
            paddingBottom: itemPaddingY,
            paddingLeft: itemPaddingX,
            paddingRight: itemPaddingX,
            fontWeight: itemFontWeight,
            fontSize: itemFontSize,
            backgroundColor: itemBackgroundColor,
            color: itemTextColor,
            borderRadius: itemBorderRadius,
            marginBottom: itemMarginBottom,
            transition: hoverAnimation
              ? `all ${animationDuration} ease`
              : "none",
          }}
          onClick={() => onItemClick(item)}
          onMouseEnter={(e) => {
            if (hoverAnimation) {
              e.target.style.backgroundColor = itemHoverBackgroundColor;
              e.target.style.color = itemHoverTextColor;
            }
          }}
          onMouseLeave={(e) => {
            if (hoverAnimation) {
              e.target.style.backgroundColor = itemBackgroundColor;
              e.target.style.color = itemTextColor;
            }
          }}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};

export default MenuList;
